import React from 'react';
import { History } from 'history';
import { InputPassword } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './user-model';  //editable..

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class UserAuthChangePassword extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }


    public componentDidMount(){
        this.setState({datarow: Model.defaultValueChangePassword as any})
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} caption={Model.caption + ' Change Password'}
                endPoint={Model.endPointAuth+ '/change-password'} model={Model} datarow={this.state.datarow} validations={Model.validationChangePassword} onError={this.onError} >              
                <InputPassword name='currentPassword' label='Current Password' value={this.state.datarow.currentPassword} error={this.state.errors?.currentPassword} onChange={this.onChange} />
                <InputPassword name='password' label='New Password' value={this.state.datarow.password} error={this.state.errors?.password} onChange={this.onChange} />
                <InputPassword name='passwordConfirmation' label='Retype New Password' value={this.state.datarow.passwordConfirmation} error={this.state.errors?.passwordConfirmation} onChange={this.onChange} />
            </BaseCreate>
        );
    }     
     
}